import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageDepixelizerConfig } from '@/data/landingConfig/landingImageDepixelizerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageDepixelizer } from './schemaObject';

const ImageDepixelizer = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageDepixelizer} />
			<LandingTemplate
				data={landingImageDepixelizerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageEnhancementV2()}
			/>
		</>
	);
};

export default ImageDepixelizer;
